export function capitalizeString(input: string) {
  if (!input) {
    return ''
  }

  return input.replace(/(^|\s|\/)[a-z]/g, function (f) {
    return f.toUpperCase()
  })
}
